import { Menu } from "@theorgchartdev/storybook";
import * as StateLib from "@/Utils/StateLib";
import { appstr } from "@coreapp/utils/appstr";
import {
  kPageNumAutoText,
  kDateAutoText,
  kTitleAutoText,
  enumBoxSubTypes,
  enumAutoTypeTypes,
  enumFileMgrMode
} from "@coreapp/constants";

const PageNumberSubOptions = (clickHandler, testId) => {
  return AutoTextOptions(clickHandler, kPageNumAutoText, testId);
};

const DateSubOptions = (clickHandler, testId) => {
  return AutoTextOptions(clickHandler, kDateAutoText, testId);
};

const TitleSubOptions = (clickHandler, testId) => {
  return AutoTextOptions(clickHandler, kTitleAutoText, testId);
};

const TableSubOptions = (clickHandler, testId) => {
  return [
    {
      label: appstr("Basic Table"),
      value: enumBoxSubTypes.refBoxTable,
      cmd: "ToolMode13",
      clickHandler: clickHandler,
      ...(testId && { dataTestId: `${testId}--${appstr("Basic Table")}` })
    },
    {
      label: appstr("Pie Chart"),
      disabled: true,
      value: enumBoxSubTypes.refChart,
      cmd: "ToolMode15",
      clickHandler: clickHandler,
      ...(testId && { dataTestId: `${testId}--${appstr("Pie Chart")}` })
    },
    {
      label: appstr("Enumerated Table"),
      disabled: true,
      value: enumBoxSubTypes.enumeratedTable,
      cmd: "ToolMode16",
      clickHandler: clickHandler,
      ...(testId && { dataTestId: `${testId}--${appstr("Enumerated Table")}` })
    }
  ];
};

const AutoTextOptions = (clickHandler, items, testId) => {
  let autoTextOptions = [];
  for (let autoText of items) {
    let optionAuto = {};
    optionAuto.label = appstr(autoText);
    optionAuto.value = autoText;
    if (testId) optionAuto.dataTestId = `${testId}--${optionAuto.label}`;
    optionAuto.clickHandler = clickHandler;
    autoTextOptions.push(optionAuto);
  }
  return autoTextOptions;
};

const insertDictList = [
  {
    label: "Page Number",
    value: enumAutoTypeTypes.pagenumbers,
    options: PageNumberSubOptions,
    isAutoText: true
  },
  {
    label: "Title",
    value: enumAutoTypeTypes.titles,
    options: TitleSubOptions,
    isAutoText: true
  },
  {
    label: "Date",
    icon: "calendar",
    value: enumAutoTypeTypes.dates,
    options: DateSubOptions,
    divider: true,
    isAutoText: true
  },
  {
    label: "Image",
    icon: "file-image",
    value: enumBoxSubTypes.picture,
    divider: true
  },
  {
    label: "textbox",
    icon: "font",
    value: enumBoxSubTypes.textBox,
    cmd: "ToolMode9"
  },
  {
    label: "Legend",
    icon: "table-columns",
    value: enumBoxSubTypes.refBoxLegend,
    cmd: "ToolMode14"
  },
  {
    label: "Table",
    icon: "table",
    value: enumAutoTypeTypes.tables,
    options: TableSubOptions
  }
];

const HandleInsert = target => {
  const workspaceMgr = StateLib.GetWSMgr();
  switch (target.value) {
    // insert image (launches file mgr)
    case 2:
      workspaceMgr.DoFileMgr(enumFileMgrMode.selectimage);
      break;
    // textbox
    case 1:
    // table
    case 3:
    // legend
    case 4:
    // pie
    case 5:
    // enum table
    case 6:
      workspaceMgr.SetToolMode(target.cmd, true);
      break;
  }
  StateLib.ReRenderCanvas();
};

const HandleInsertAutoText = target => {
  const workspaceMgr = StateLib.GetWSMgr();
  workspaceMgr.AutoTextToolMode(target.value);
  StateLib.ReRenderCanvas();
};

// tagLeafItems: false skips per-item dataTestId, leaving only popover-level tags
export const BuildInsertOptions = ({
  clickHandler,
  autoTextClickHandler,
  testId,
  tagLeafItems = true
}) => {
  let insertOptions2 = [];
  for (let insertOption of insertDictList) {
    var singleOption = {};
    singleOption.label = appstr(insertOption.label);
    singleOption.value = insertOption.value;
    singleOption.icon = insertOption.icon;
    singleOption.cmd = insertOption.cmd;
    singleOption.divider = insertOption.divider;
    singleOption.disabled = insertOption.disabled;
    if (insertOption.options) {
      if (tagLeafItems && testId) singleOption.dataTestId = `${testId}--${insertOption.label}`;
      singleOption.options = insertOption.options(
        insertOption.isAutoText ? (autoTextClickHandler ?? clickHandler) : clickHandler,
        tagLeafItems ? testId : undefined
      );
    } else {
      singleOption.clickHandler = clickHandler;
      if (tagLeafItems && testId) singleOption.dataTestId = `${testId}--${insertOption.label}`;
    }
    insertOptions2.push(singleOption);
  }
  return insertOptions2;
};

const InsertMenu = props => {
  return (
    <Menu
      showCheck={false}
      label={appstr("Insert")}
      options={BuildInsertOptions({
        clickHandler: HandleInsert,
        autoTextClickHandler: HandleInsertAutoText
      })}
      {...props}
    />
  );
};

export default InsertMenu;
